/* eslint jsx-a11y/no-static-element-interactions:0 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import Textarea from 'react-textarea-autosize';

const Note = ({ raceType, raceTypeName, rating, ratingFlag, note, onChange }) => (
    <div>
        <h3 className="hp-notes__title">{raceTypeName}</h3>
        <div className="hp-notes__note">
            <div className="hp-notes__fieldSet">
                <label className="hp-notes__label" htmlFor={`${raceType}_note`}>
                    <span className="hp-notes__label_type">{raceTypeName}</span>
                        Note
                </label>
                <div
                    className={classNames(
                        'hp-notes__input_container',
                        note && 'hp-notes__icon_hidden'
                    )}
                >
                    <Textarea
                        onChange={onChange}
                        name="note"
                        value={note}
                        id={`${raceType}_note`}
                        rows={1}
                        maxLength={250}
                        className="ui-input hp-notes__input"
                    />
                    <span
                        className="hp-notes__icon"
                    >
                        <Svg iconName="note" size="Medium" />
                    </span>
                </div>
            </div>
            <div className="hp-notes__fieldSetWrapper">
                <div className="hp-notes__fieldSet hp-notes__fieldSet_rating">
                    <label className="hp-notes__label" htmlFor={`${raceType}_rating`}>
                        Rating
                    </label>
                    <input
                        onChange={onChange}
                        type="text"
                        name="rating"
                        value={rating}
                        id={`${raceType}_rating`}
                        maxLength={3}
                        className="ui-input hp-notes__input hp-notes__input_rating"
                    />
                </div>
                <div className="hp-notes__fieldSet hp-notes__fieldSet_ratingFlag">
                    <label className="hp-notes__label" htmlFor={`${raceType}_ratingFlag`}>
                        +/-
                    </label>
                    <input
                        onChange={onChange}
                        type="text"
                        name="ratingFlag"
                        value={ratingFlag}
                        id={`${raceType}_ratingFlag`}
                        maxLength={1}
                        className="ui-input hp-notes__input hp-notes__input_ratingFlag"
                    />
                </div>
            </div>
        </div>
        <div className="ui-divider" />
    </div>
);

Note.propTypes = PropTypes.shape({
    raceType: PropTypes.string.isRequired,
    raceTypeName: PropTypes.string.isRequired,
    rating: PropTypes.string,
    flag: PropTypes.string,
    note: PropTypes.string,
    onChange: PropTypes.func,
}).isRequired;

export default Note;



// WEBPACK FOOTER //
// ./src/js/horse/notes/components/Note.jsx